import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Modal, Button } from 'ancestry-ui-react';

// data from redux
import {
  // selectors
  activeModalSelector,
  loadingSelector,
  errorSelector,
  contentSelector,
  // action
  closeBoardInfoModal
} from '../../ducks/board-info';
import { entitiesSelector } from '../../ducks/home-category-page';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFolderOpen, faComments } from '@fortawesome/free-solid-svg-icons';
import { FormattedMessage } from 'react-intl';
import m from './messages';
import { CATEGORY_TYPES } from '../../constants';

export default function BoardInfo() {
  const dispatch = useDispatch();

  const activeModal = useSelector(activeModalSelector);
  const entities = useSelector(entitiesSelector);
  const loading = useSelector(loadingSelector);
  const content = useSelector(contentSelector);
  const error = useSelector(errorSelector);
  const errorDefaultMsg = 'Something happened wrong...';

  const handleClose = () => dispatch(closeBoardInfoModal());

  const renderContent = () => {
    const boardName = entities.title;

    if (error) {
      return (
        <>
          <h2 id="alert-dialog-title" className="conTitle">Error occured</h2>
          <div id="alert-dialog-description">
            {errorDefaultMsg}
          </div>
        </>
      );
    }

    if (content) {
      return (
        <>
          <div className="boards-info-modal__content">
            <div dangerouslySetInnerHTML={{ __html: content }} />
          </div>
          <div className="boards-info-modal__actions">
            <Button onClick={handleClose}>
              <FormattedMessage {...m.close} />
            </Button>
          </div>
        </>
      );
    }

    return (
      <>
        <div className="boards-info-modal__content">
          <h3 className="categories__title">
            { boardName && (
              <>
                <FontAwesomeIcon icon={entities.nodeType === CATEGORY_TYPES.category ? faFolderOpen : faComments} />
                <FormattedMessage {...m.title} values={{ name: boardName }} />
              </>
            )
            }
          </h3>
          <FormattedMessage {...m.contact} />
        </div>
        <div className="boards-info-modal__actions">
          <Button onClick={handleClose} data-testid="close-button">
            <FormattedMessage {...m.close} />
          </Button>
        </div>
      </>
    );
  };

  return (
    <Modal
      open={!!activeModal}
      hideCloseBtn
      closeOnBkgClick
      onClose={handleClose}
      showLoading={!!loading}
      ariaLabelledby="board-information-dialog"
      width={loading ? 300 : 990}
    >
      {!loading && (
        <div className="boards-info-modal" aria-describedby="board-information-content">
          {renderContent()}
        </div>
      )}
    </Modal>
  );
}

